export function convertToSIPrefix(number, unit) {
  const prefixes = [
    { prefix: "", factor: 1 },
    { prefix: "k", factor: 1e3 },
    { prefix: "M", factor: 1e6 },
    { prefix: "G", factor: 1e9 },
    { prefix: "T", factor: 1e12 },
    { prefix: "P", factor: 1e15 },
    { prefix: "E", factor: 1e18 },
    { prefix: "Z", factor: 1e21 },
    { prefix: "Y", factor: 1e24 },
  ];

  let result = number;
  let prefix = "";

  for (let i = prefixes.length - 1; i >= 0; i--) {
    const { prefix: currentPrefix, factor } = prefixes[i];

    if (Math.abs(result) >= factor) {
      result /= factor;
      prefix = currentPrefix;
      break;
    }
  }

  return `${result.toFixed(1)} ${prefix}${unit}`;
}

export function toEngineeringNotation(number, unit) {
  let exponent = Math.floor(Math.log10(Math.abs(number)));
  const exponentMultiple = Math.floor(exponent / 3) * 3;
  const mantissa = number / Math.pow(10, exponentMultiple);

  return `${mantissa.toFixed(1)} × 10^${exponentMultiple} ${unit}`;
}

export function toEngineeringNotationReadable(number, unit) {
  const suffixes = [
    { label: "", factor: 1 },
    { label: "thousand", factor: 1e3 },
    { label: "million", factor: 1e6 },
    { label: "billion", factor: 1e9 },
    { label: "trillion", factor: 1e12 },
    { label: "quadrillion", factor: 1e15 },
    { label: "quintillion", factor: 1e18 }
  ];

  let result = Math.abs(number);
  let suffix = "";

  for (let i = suffixes.length - 1; i >= 0; i--) {
    const { label, factor } = suffixes[i];
    if (result >= factor) {
      result /= factor;
      suffix = label;
      break;
    }
  }

  return `${result.toFixed(1)} ${suffix} ${unit}`;
}
